import { ModalityIncludedExtra } from '../models/types';

export function formatIncludedExtraName(extra: ModalityIncludedExtra): string {
    const units = Number(extra.included_units);
    if (units > 1) {
        return `${extra.extra_name} (hasta ${units} unidades)`;
    }
    return extra.extra_name;
}
